/* Blessed Obsession — scripts propios (vanilla, sin librerías) */
(function () {
  if (window.__boInit) return;
  window.__boInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Altura de la cabecera → variable CSS */
  function medirHeader() {
    var h = document.querySelector('.section-header');
    if (h) document.documentElement.style.setProperty('--bo-header-h', h.offsetHeight + 'px');
    var a = document.querySelector('.announcement-bar-section');
    document.documentElement.style.setProperty('--bo-anuncio-h', (a && document.body.classList.contains('bo-tpl-index') ? a.offsetHeight : 0) + 'px');
  }

  /* Titulares por palabras: respeta <em> como una sola palabra */
  function partirPalabras(el) {
    if (el.dataset.boWords) return;
    el.dataset.boWords = '1';
    var nodos = Array.prototype.slice.call(el.childNodes);
    el.innerHTML = '';
    nodos.forEach(function (n) {
      if (n.nodeType === 3) {
        n.textContent.split(/(\s+)/).forEach(function (t) {
          if (!t) return;
          if (/^\s+$/.test(t)) { el.appendChild(document.createTextNode(' ')); return; }
          var w = document.createElement('span'); w.className = 'bo-word';
          var i = document.createElement('span'); i.textContent = t; w.appendChild(i); el.appendChild(w);
        });
      } else if (n.nodeName === 'BR') {
        el.appendChild(n);
      } else {
        var w2 = document.createElement('span'); w2.className = 'bo-word';
        var i2 = document.createElement('span'); i2.appendChild(n); w2.appendChild(i2); el.appendChild(w2);
      }
    });
    var k = 0;
    el.querySelectorAll('.bo-word > span').forEach(function (s) { s.style.transitionDelay = (k++ * 0.08) + 's'; });
  }

  /* Reveals */
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('bo-visible'); io.unobserve(e.target); }
    });
  }, { threshold: 0.18, rootMargin: '0px 0px -6% 0px' }) : null;

  function initReveals(root) {
    root.querySelectorAll('.bo-words').forEach(partirPalabras);
    root.querySelectorAll('.bo-reveal, .bo-words, [data-bo-reveal]').forEach(function (el) {
      if (el.dataset.boRev) return; el.dataset.boRev = '1';
      if (!io || reduce) el.classList.add('bo-visible'); else io.observe(el);
    });
  }

  /* Paralaje (lookbook y panorámica) */
  var capas = [];
  function initParallax(root) {
    root.querySelectorAll('[data-bo-parallax]').forEach(function (el) {
      if (el.dataset.boPar) return; el.dataset.boPar = '1';
      capas.push(el);
    });
  }
  var pendiente = false;
  function pintarParallax() {
    pendiente = false;
    var vh = window.innerHeight;
    capas.forEach(function (el) {
      if (!el.isConnected) return;
      var padre = el.parentElement, r = padre.getBoundingClientRect();
      if (r.bottom < -200 || r.top > vh + 200) return;
      var v = parseFloat(el.dataset.boParallax) || 0;
      var centro = r.top + r.height / 2 - vh / 2;
      var max = (el.offsetHeight - padre.offsetHeight) / 2;
      var y = Math.max(-max, Math.min(max, -centro * v));
      el.style.transform = 'translate3d(0,' + y.toFixed(1) + 'px,0)';
    });
  }
  function pedirParallax() { if (!pendiente && !reduce) { pendiente = true; requestAnimationFrame(pintarParallax); } }

  /* Flechas del lookbook (sin "teletransporte") */
  function initLookbook(root) {
    root.querySelectorAll('[data-bo-look]').forEach(function (sec) {
      if (sec.dataset.boLk) return; sec.dataset.boLk = '1';
      var pista = sec.querySelector('.bo-look__pista');
      if (!pista) return;
      sec.querySelectorAll('[data-bo-dir]').forEach(function (b) {
        b.addEventListener('click', function () {
          var items = pista.querySelectorAll('.bo-look__item');
          if (items.length < 2) return;
          var paso = items[1].offsetLeft - items[0].offsetLeft;
          var actual = Math.round(pista.scrollLeft / paso);
          var destino = Math.max(0, Math.min(pista.scrollWidth - pista.clientWidth, (actual + parseInt(b.dataset.boDir, 10)) * paso));
          var ini = pista.scrollLeft, dif = destino - ini, t0 = null, dur = reduce ? 1 : 750;
          pista.classList.add('bo-sin-snap');
          function ease(t) { return t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
          function paso2(ts) {
            if (!t0) t0 = ts;
            var p = Math.min(1, (ts - t0) / dur);
            pista.scrollLeft = ini + dif * ease(p);
            if (p < 1) requestAnimationFrame(paso2); else pista.classList.remove('bo-sin-snap');
          }
          requestAnimationFrame(paso2);
        });
      });
      pista.addEventListener('scroll', pedirParallax, { passive: true });
    });
  }

  /* Formulario de producto: talla → variante */
  function formatear(cents) {
    try {
      if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(cents);
      var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
      return new Intl.NumberFormat(document.documentElement.lang || 'es', { style: 'currency', currency: cur }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(2); }
  }
  function initFormularios(root) {
    root.querySelectorAll('[data-bo-producto]').forEach(function (cont) {
      if (cont.dataset.boPf) return; cont.dataset.boPf = '1';
      var json = cont.querySelector('[data-bo-variantes]');
      if (!json) return;
      var variantes = JSON.parse(json.textContent);
      var input = cont.querySelector('input[name="id"]');
      var precios = document.querySelectorAll('[data-bo-precio="' + cont.dataset.boProducto + '"]');
      var botones = document.querySelectorAll('[data-bo-add="' + cont.dataset.boProducto + '"]');
      var sets = cont.querySelectorAll('.bo-opcion');
      function actualizar() {
        var sel = [];
        sets.forEach(function (fs) { var c = fs.querySelector('input:checked'); sel.push(c ? c.value : null); });
        var v = variantes.find(function (x) { return x.options.every(function (o, i) { return sel[i] === null || o === sel[i]; }); });
        // tallas agotadas para la combinación actual
        sets.forEach(function (fs, idx) {
          fs.querySelectorAll('.bo-talla').forEach(function (lab) {
            var val = lab.querySelector('input').value;
            var hay = variantes.some(function (x) { return x.available && x.options.every(function (o, i) { return i === idx ? o === val : (sel[i] === null || o === sel[i]); }); });
            lab.classList.toggle('bo-talla--agotada', !hay);
          });
        });
        if (!v) return;
        if (input) input.value = v.id;
        precios.forEach(function (p) { p.textContent = formatear(v.price); });
        botones.forEach(function (b) {
          b.disabled = !v.available;
          var t = b.querySelector('[data-bo-add-texto]');
          if (t) t.textContent = v.available ? b.dataset.textoOk : b.dataset.textoAgotado;
        });
      }
      cont.addEventListener('change', function (e) { if (e.target.closest('.bo-opcion')) actualizar(); });
      actualizar();
    });
  }

  /* Guía de tallas (dialog) */
  function initDialogos(root) {
    root.querySelectorAll('[data-bo-abrir-tallas]').forEach(function (b) {
      if (b.dataset.boDg) return; b.dataset.boDg = '1';
      b.addEventListener('click', function () {
        var d = document.getElementById(b.dataset.boAbrirTallas);
        if (d && d.showModal) d.showModal();
      });
    });
    root.querySelectorAll('.bo-dialogo').forEach(function (d) {
      if (d.dataset.boDc) return; d.dataset.boDc = '1';
      d.addEventListener('click', function (e) { if (e.target === d || e.target.closest('[data-bo-cerrar]')) d.close(); });
    });
  }

  /* Barra de compra fija en móvil */
  function initSticky(root) {
    root.querySelectorAll('[data-bo-sticky]').forEach(function (bar) {
      if (bar.dataset.boSt) return; bar.dataset.boSt = '1';
      var ref = document.getElementById(bar.dataset.boSticky);
      if (!ref || !io) return;
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { bar.classList.toggle('bo-sticky--on', !e.isIntersecting && e.boundingClientRect.top < 0); });
      }).observe(ref);
      var b = bar.querySelector('button');
      if (b) b.addEventListener('click', function () {
        var f = document.getElementById(bar.dataset.boForm);
        if (f) { if (f.requestSubmit) f.requestSubmit(); else f.submit(); }
      });
    });
  }

  /* Manifiesto: cada palabra se enciende según avanza el bloque en pantalla */
  var luces = [];
  function initLuz(root) {
    root.querySelectorAll('[data-bo-luz]').forEach(function (p) {
      if (p.dataset.boLz) return; p.dataset.boLz = '1';
      var nodos = Array.prototype.slice.call(p.childNodes); p.innerHTML = '';
      nodos.forEach(function (n) {
        if (n.nodeType === 3) {
          n.textContent.split(/(\s+)/).forEach(function (t) {
            if (!t) return;
            if (/^\s+$/.test(t)) { p.appendChild(document.createTextNode(' ')); return; }
            var s = document.createElement('span'); s.className = 'bo-luz__w'; s.textContent = t; p.appendChild(s);
          });
        } else if (n.nodeName === 'BR') { p.appendChild(n); }
        else { n.classList.add('bo-luz__w'); p.appendChild(n); }
      });
      luces.push(p);
    });
  }
  function pintarLuz() {
    var vh = window.innerHeight;
    luces.forEach(function (p) {
      if (!p.isConnected) return;
      var r = p.getBoundingClientRect();
      var prog = (vh * 0.85 - r.top) / (r.height + vh * 0.35);
      prog = Math.max(0, Math.min(1, prog));
      var ws = p.querySelectorAll('.bo-luz__w'), n = Math.round(prog * ws.length);
      ws.forEach(function (w, i) { w.classList.toggle('bo-on', reduce || i < n); });
    });
  }

  /* Nombre gigante del pie: ajusta el tamaño para ocupar todo el ancho */
  function ajustarMarca() {
    document.querySelectorAll('[data-bo-fit]').forEach(function (el) {
      var cont = el.parentElement; el.style.fontSize = '100px';
      var w = el.scrollWidth; if (!w) return;
      el.style.fontSize = Math.floor(100 * cont.clientWidth / w * 0.995) + 'px';
    });
  }

  function init(root) {
    root = root || document;
    initLuz(root);
    pintarLuz();
    ajustarMarca();
    medirHeader();
    initReveals(root);
    initParallax(root);
    initLookbook(root);
    initFormularios(root);
    initDialogos(root);
    initSticky(root);
    pedirParallax();
  }

  window.addEventListener('scroll', function () { pedirParallax(); pintarLuz(); }, { passive: true });
  window.addEventListener('resize', function () { medirHeader(); pedirParallax(); ajustarMarca(); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(ajustarMarca);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
